// Global initialization flag
let gMapsInitialized = false;

// Initialization callback after Google Maps JavaScript is loaded
window.googleMapInit = () => {
    gMapsInitialized = true;

    // Process initialization backlog for each map
    $('.js-map').each(function() {
        const backlog = $(this).data('map-init-backlog') || [];
        backlog.forEach(b => b());
    });
};

/**
 * Set user marker to the map
 * @param {jQuery} $map The map element to add the marker to
 * @param {Object} coordinates Both latitude and longitude
 */
window.setUserCoordinates = ($map, coordinates) => {
    addMarker($map, coordinates);
    const setUserToBounds = () => {
        if (!$map.data('original-bounds')) {
            addToBounds($map, coordinates);
        }
    };
    if ($map.data('loaded')) {
        setUserToBounds();
    } else {
        addToLoadBacklog($map, setUserToBounds);
    }
};

/**
 * Add a function to the load backlog of a map
 */
const addToLoadBacklog = ($map, func) => {
    $map.data('map-load-backlog', $map.data('map-load-backlog') || []);
    $map.data('map-load-backlog').push(func);
}

/**
 * Add a marker to a map
 * @param {jQuery} $map The map element to add the marker to
 * @param {Object} coordinates Both latitude and longitude
 * @param {Object}[config] Icon and window URL
 * @param {jQuery}[$attachTo] Element to set data-marker of with the created marker
 */
export function addMarker($map, coordinates, config = {}, $attachTo = undefined) {
    if (!$map.data('loaded')) {
        addToLoadBacklog($map, function() {
            addMarker($map, coordinates, config, $attachTo);
        });
        return;
    }

    const map    = $map.data('map');
    const marker = new google.maps.Marker({
        map:      map,
        position: new google.maps.LatLng(coordinates.latitude, coordinates.longitude),
    });
    if (config.hasOwnProperty('icon')) {
        if (typeof config.icon === 'string') {
            config.icon = {
                url:        config.icon,
                scaledSize: new google.maps.Size(30, 35),
                anchor:     new google.maps.Point(15, 35),
                origin:     new google.maps.Point(0, 0),
            };
        }
        marker.setIcon(config.icon);
    }
    if (config.hasOwnProperty('window')) {
        marker.setClickable(true);
        marker.addListener('click', () => {
            let infoWindows = $map.data('map-windows') || [];
            infoWindows.forEach(i => i.close());
            infoWindows = [];
            $.get(config.window)
                .done((data) => {
                    const infoWindow = new google.maps.InfoWindow({content: data});
                    infoWindow.open(map, marker);
                    infoWindows.push(infoWindow);
                    $map.data('map-windows', infoWindows);
                })
                .fail((xhr) => {
                    if (xhr.statusText === 'abort') {
                        return;
                    }
                    alert('Er ging iets mis met het ophalen van de winkel informatie');
                });
        });
    }
    if (config.hasOwnProperty('zoom')) {
        map.setCenter(marker.getPosition());
        map.setZoom(config.zoom === true ? 17 : config.zoom);
    }
    if ($attachTo) {
        $attachTo.data('marker', marker);
    }
}

/**
 * Expand bounds of a map with the given coordinates
 * @param {jQuery} $map The map element to add the marker to
 * @param {Object} coordinates Both latitude and longitude
 */
export function addToBounds($map, coordinates) {
    if (!$map.data('loaded')) {
        addToLoadBacklog($map, function() {
            addToBounds($map, coordinates);
        });
        return;
    }

    /** @var map google.maps.Map */
    const map  = $map.data('map');
    let bounds = $map.data('original-bounds') ? new google.maps.LatLngBounds() : (map.getBounds() || new google.maps.LatLngBounds());
    bounds     = bounds.extend(new google.maps.LatLng(coordinates.latitude, coordinates.longitude));
    map.fitBounds(bounds, 10);
    $map.data('original-bounds', false);

}

export default ($container) => {
    $('.js-map', $container).each(function() {
        const $map     = $(this);
        const setupMap = () => {
            const map = new google.maps.Map(this, {
                // Default center to entire Netherlands
                center:            new google.maps.LatLng(52.2129919, 5.2793703),
                zoom:              7,
                zoomControl:       true,
                fullscreenControl: true,
                streetViewControl: true,
                mapTypeId:         google.maps.MapTypeId.ROADMAP,
                disableDefaultUI:  true,
            });
            $map.data('map', map);
            google.maps.event.addListenerOnce(map, 'tilesloaded', () => {
                $map.data('loaded', true);
                $map.data('original-bounds', true);
                const backlog = $map.data('map-load-backlog') || [];
                backlog.forEach(b => b());
            });
        };
        if (gMapsInitialized) {
            setupMap();
        } else {
            $map.data('map-init-backlog', [setupMap]);
        }
    });
}
